import { useTranslation } from 'react-i18next';
import Switch from "react-switch";
import React, { useState, useEffect, useRef } from 'react';

const ConsentModal = ({ modal, setModal }) => {
    const { t, i18n } = useTranslation();
    const [internalCheck, setInternalCheck] = useState(false);
    const divButtonStyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto"
    }
    if (modal.show === false) return (<></>);
    return (
        <div className="modal" tabIndex="-1" style={{ display: modal.show ? "block" : "none" }}>
            <div className={`modal-dialog ${modal.size}`}>
                <div className="modal-content">
                    <div className="modal-header">
                        {/* <button type="button" className="btn-close" onClick={() => { setModal({ ...modal, show: false }) }} aria-label="Close"></button> */}
                    </div>
                    <div className="d-flex justify-content-start align-items-center">
                        <div className="d-flex justify-content-start m-2">
                            <Switch
                                width={42}
                                height={21}
                                checkedIcon={false}
                                uncheckedIcon={false}
                                checked={internalCheck}
                                onChange={function (checked) {
                                    modal.setFormData(prev => ({ ...prev, consentTwo: checked }));
                                    setInternalCheck(checked);
                                }}
                            />
                        </div>
                        <div className="m-2">
                            <label className="form-check-label" htmlFor="termsCheck">{i18n.t("check_two")}</label>
                        </div>
                    </div>
                    <div className="modal-footer" style={divButtonStyle}>
                        <button type="button" className="btn btn-loropiana btn-optima" onClick={function () {
                            setModal({ ...modal, show: false });
                            modal.setFormData(prev => ({ ...prev, consentTwo: internalCheck }));
                            modal.setAutoSubmit(true);
                        }}>{t("confirm")}</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConsentModal;